import { PrimaryButton } from '@huggg/react-components';
import { moreInformationPage } from 'config/dictionary';
import { useAnalytics } from 'hooks';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { getBasePathname } from 'utilities/huggg';
import styles from '../more-details.module.scss';

const StashButton = (props) => {
  const { huggg, isStashed, disabled } = props;
  const analytics = useAnalytics();

  const onClick = useCallback(() => {
    analytics.buttonClickSuperhugggActionsStash();
  }, [analytics]);

  if (isStashed) {
    return null;
  }

  return (
    <Link
      to={`${getBasePathname(huggg)}/stash`}
      onClick={onClick}
      disabled={disabled}
      style={{ width: '320px', marginTop: '8px', textDecoration: 'none' }}
    >
      <PrimaryButton
        label={moreInformationPage.superhuggg.stashButton}
        disabled={disabled}
        className={styles.CTAButton}
      />
    </Link>
  );
};

StashButton.propTypes = {
  huggg: PropTypes.object.isRequired,
  isStashed: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
};

export default StashButton;
